import { render, staticRenderFns } from "./NftSelection.vue?vue&type=template&id=2bf541e0&scoped=true&"
import script from "./NftSelection.vue?vue&type=script&lang=js&"
export * from "./NftSelection.vue?vue&type=script&lang=js&"
import style0 from "./NftSelection.vue?vue&type=style&index=0&id=2bf541e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf541e0",
  null
  
)

export default component.exports